import { xd } from "../utils";

const dev = {
  //dev
  //bU: xd("aHR0cDovLzE5Mi4xNjguMjAuMTk6ODA4MA=="), //http://192.168.20.19:8080
  //homol
  bU: xd("aHR0cHM6Ly9zMjAyLmZhY2hlc2YuY29tLmJy"), //https://s202.fachesf.com.br
  hashHeader: xd(
    "NDlWOThIMTcxVjIxNlEyNDAqMzQyQTEzMDlaNDAwVjQzMi4xODcwSDYwNUEyMjQ0LTYzN1o3NDItNzA1JDc2OFo5MTgkODQ2Vjk1MC45NjBIMTA1MEAxMDU2LjQzMDFAMTE3NlYxMzUwQDEyMjIqMTI5Ni0xNDI4JDEzNjNWMTUwMFYxNDg4KjE4MjRLMTg4MQ=="
  ),
  patrocinadorInstituidor: "I",
  idUsuario: 167,
  PowerForm: xd(
    "aHR0cHM6Ly9zMjAyLmZhY2hlc2YuY29tLmJyL3Jlc3QtYXNzaW5hdHVyYS1kaWdpdGFsL2NhcnJlZ2FEb2N1bWVudG8uaHRtbD8mZG9jPQ=="
  ),
};

const homol = {
  bU: xd("aHR0cHM6Ly9zMjAyLmZhY2hlc2YuY29tLmJy"),
  hashHeader: xd(
    "NDlWOThIMTcxVjIxNlEyNDAqMzQyQTEzMDlaNDAwVjQzMi4xODcwSDYwNUEyMjQ0LTYzN1o3NDItNzA1JDc2OFo5MTgkODQ2Vjk1MC45NjBIMTA1MEAxMDU2LjQzMDFAMTE3NlYxMzUwQDEyMjIqMTI5Ni0xNDI4JDEzNjNWMTUwMFYxNDg4KjE4MjRLMTg4MQ=="
  ),
  patrocinadorInstituidor: "I",
  idUsuario: 167,
  PowerForm: xd(
    "aHR0cHM6Ly9zMjAyLmZhY2hlc2YuY29tLmJyL3Jlc3QtYXNzaW5hdHVyYS1kaWdpdGFsL2NhcnJlZ2FEb2N1bWVudG8uaHRtbD8mZG9jPQ=="
  ),
};

const prod = {
  bU: xd("aHR0cHM6Ly9hcGkuZmFjaGVzZi5jb20uYnI6MTA0NDM="),
  hashHeader: xd(
    "NDlWOThIMTcxVjIxNlEyNDAqMzQyQTEzMDlaNDAwVjQzMi4xODcwSDYwNUEyMjQ0LTYzN1o3NDItNzA1JDc2OFo5MTgkODQ2Vjk1MC45NjBIMTA1MEAxMDU2LjQzMDFAMTE3NlYxMzUwQDEyMjIqMTI5Ni0xNDI4JDEzNjNWMTUwMFYxNDg4KjE4MjRLMTg4MQ=="
  ),
  patrocinadorInstituidor: "I",
  idUsuario: 167,
  PowerForm: xd(
    "aHR0cHM6Ly9hcGkuZmFjaGVzZi5jb20uYnI6MTA0NDMvcmVzdC1hc3NpbmF0dXJhLWRpZ2l0YWwvY2FycmVnYURvY3VtZW50by5odG1sPyZkb2M9"
  ),
};

function RealizePrev() {
  // eslint-disable-next-line no-eval
  return dev;
  return eval(process.env.REACT_APP_HOST_ENV!);
}

export default RealizePrev;
